import { Image, ImageProps } from '@chakra-ui/react';
import { FC } from 'react';

export type PlatformIconProps = ImageProps & {
  platformKey?: string;
  width?: number;
  height?: number;
};

export const PlatformIcon: FC<PlatformIconProps> = ({ platformKey, width = 16, height = 16, ...rest }) => {
  return platformKey ? (
    <Image
      src={`/assets/platforms/${platformKey.toLowerCase()}/icon.svg`}
      width={width}
      height={height}
      fallback={<></>}
      {...rest}
    />
  ) : null;
};
